import { actions as snactions } from '../../snackbar'
import service from '../parent-api-service'
import types from '../types'
import fetchParents from './fetch'

const createParent = (parent, invite) => (dispatch) => {
  dispatch({
    type: types.CREATE_PARENTS_START,
  })
  return service
    .createParent(parent, invite)
    .then(() => {
      dispatch({ type: types.CREATE_PARENTS_SUCCESS })
      if (invite) {
        dispatch(snactions.addSnackbarItem('Invitation was sent'))
      }
      dispatch(fetchParents())
    })
    .catch(() => {
      dispatch({ type: types.CREATE_PARENTS_FAILURE })
      dispatch(snactions.addSnackbarItem('An error occured when creating a parent'))
    })
}

export default createParent
